import { getReleaseGuardianEntitlementsQuery } from '@gonfalon/rest-api/queries/automatedReleases';
import { useQuery } from '@tanstack/react-query';

type Options = ReturnType<typeof getReleaseGuardianEntitlementsQuery> & {
  flagPurpose?: string;
};

export const useReleaseGuardian = (options: Omit<Options, 'queryKey' | 'queryFn'> = {}) => {
  const { flagPurpose = '' } = options;
  const entitlementQuery = useQuery({
    ...getReleaseGuardianEntitlementsQuery(),
    ...options,
    staleTime: 60000, // 1 minute
    retry: (retryCount) => retryCount < 3,
    refetchOnWindowFocus: false,
  });

  const { data: entitlementData } = entitlementQuery;
  const state = entitlementData?.state;
  const enableForAI = flagPurpose === 'ai';

  return {
    entitlements: entitlementData,
    isPending: entitlementQuery.isPending,
    isTrial: state !== undefined && state !== 'disabled' && state !== 'enabled',
    isReleaseGuardianEnabled: (state !== undefined && state !== 'disabled') || enableForAI,
    isHardLimitReached: state === 'disabled-upsell' || state === 'disabled',
    isSoftLimitReached: state !== undefined && state !== 'enabled' && state !== 'enabled-ugt-available',
  };
};
